import React, { useEffect } from 'react';
import {
  Box,
  Snackbar,
  Alert
} from '@mui/material';
import { useUserMarkingCodes } from './hooks/useUserMarkingCodes';
import { UserMarkingCodesToolbar } from './components/UserMarkingCodesToolbar';
import { UserMarkingCodesTable } from './components/UserMarkingCodesTable';
import DocumentViewDialog from '../Documents/DocumentViewDialog';

export const UserMarkingCodes: React.FC = () => {
  const {
    items,
    totalCount,
    isLoading,
    filters,
    page,
    pageSize,
    userRole,
    storages,
    statuses,
    types,
    notification,
    selectedDocument,
    isDocLoading,
    isDocDialogOpen,
    setPage,
    setPageSize,
    handleRefresh,
    handleExport,
    handleFilterChange,
    handleSort,
    handleResetFilters,
    handleOpenDocument,
    handleCloseDocument,
    closeNotification
  } = useUserMarkingCodes();

  useEffect(() => {
    document.title = 'Коды маркировки (КМ) | Zerde';
  }, []);

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Тулбар с фильтрами: поиск, направление, тип, статус, даты и действия */}
      <UserMarkingCodesToolbar
        filters={filters}
        isLoading={isLoading}
        userRole={userRole}
        storages={storages}
        statuses={statuses}
        types={types}
        onFilterChange={handleFilterChange}
        onRefresh={handleRefresh}
        onExport={handleExport}
        onResetFilters={handleResetFilters}
      />

      {/* Таблица с сортировкой, индикаторами направления и кликом на документ */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <UserMarkingCodesTable
          items={items}
          totalCount={totalCount}
          isLoading={isLoading}
          page={page}
          pageSize={pageSize}
          orderBy={filters.orderBy}
          order={filters.order}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          onSort={handleSort}
          onOpenDocument={handleOpenDocument}
        />
      </Box>

      {/* Диалог детального просмотра документа пользователя с возможностью выгрузки КМ */}
      <DocumentViewDialog
        open={isDocDialogOpen}
        document={selectedDocument}
        loading={isDocLoading}
        onClose={handleCloseDocument}
      />

      {/* Уведомление */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={closeNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={closeNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%', borderRadius: 2 }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UserMarkingCodes;
